module.exports = __webpack_public_path__ + "static/media/jhc_logo.04e7fe4f.png";